import { v4 as uuidv4 } from 'uuid';

import { consentTelemetry } from '../api';
import { logError } from '../log';
import { resolveAppLocale } from '../mobile/appLocale';
import { isAndroid, isCordova, isIOS } from '../mobile/deviceDetection';

let promptId = null;

/** Starts a new banner impression; links `shown` to the decision. */
export const newPrompt = () => {
  promptId = uuidv4();
  return promptId;
};

const platform = () => (isCordova() ? (isIOS() ? 'ios' : isAndroid() ? 'android' : 'web') : 'web');

// Fire-and-forget: never awaited, never throws.
const send = (fields) => {
  try {
    if (typeof window === 'undefined') return;
    // Decisions made via the footer "Cookie settings" link never went through
    // the banner (which is what calls newPrompt), so promptId would be null and
    // the change — including a withdrawal — would be silently dropped. Mint one.
    if (!promptId) newPrompt();
    consentTelemetry({ promptId, platform: platform(), ...fields }).catch(() => {});
  } catch (e) {
    logError(e, 'consent-telemetry');
  }
};

/**
 * Consent banner/settings telemetry.
 * @param {'shown'|'accept_all'|'custom'|'necessary_only'} action
 * @param {{statistics?: boolean, marketing?: boolean}} categories
 * @param {string} [locale]
 */
export const sendConsentTelemetry = (
  action,
  { statistics = null, marketing = null } = {},
  locale
) => send({ action, statistics, marketing, locale });

/**
 * The iOS App Tracking Transparency answer, under the same promptId as the banner decision
 * of this session so the ATT rate per marketing consent can be joined.
 * @param {'authorized'|'denied'|'restricted'|'not_determined'} attStatus
 */
export const sendAttTelemetry = (attStatus) =>
  send({ action: 'att_response', attStatus, locale: resolveAppLocale() });
